// extracted by mini-css-extract-plugin
export default {"invoiceCell":"billing-history-table_invoiceCell__yo8rP","tableWrapper":"billing-history-table_tableWrapper__5x163"};